export default {
    auth: {
        attendance_success: "📅 出席チェック完了! (Daily Rewards)\n今日のボーナス+50ポイントを獲得しました!",
        signup_bonus: "登録完了! 🎉\nウェルカムボーナス+100ポイントを獲得しました!",
        referral_bonus: "招待登録完了! 🤝\nウェルカムボーナス100P + 招待ボーナス500P\n合計600ポイントを獲得しました!",
        login_required: "ログインが必要です"
    },
    social: {
        subscribe_on: "購読リストに追加しました。",
        subscribe_off: "購読を解除しました。",
        like_on: "いいねしました!",
        like_off: "いいねを取り消しました。",
        follow_on: "フォローしました。",
        follow_off: "フォローを解除しました。"
    },
    comment: {
        submit_success: "コメントを投稿しました。",
        delete_confirm: "本当に削除しますか?",
        delete_success: "削除しました。",
        delete_error: "削除エラー",
        submit_error: "コメントの投稿エラー",
        empty_error: "内容を入力してください。"
    },
    payment: {
        verify_success: "確認完了!\n{amount}スターがチャージされました。",
        verify_fail: "確認エラー",
        user_cancel: "支払いがキャンセルされました。",
        error: "支払エラー"
    },
    common: {
        confirm: "確認",
        cancel: "キャンセル",
        close: "閉じる",
        save: "保存",
        delete: "削除",
        edit: "編集",
        copy: "コピー",
        loading: "読み込み中...",
        error: "エラーが発生しました。",
        success: "成功しました。",
        webtoon: "ウェブトゥーン",
        webnovel: "ウェブ小説",
        cinenovel: "シネノベル",
        published: "公開済み",
        draft: "下書き",
        editor: "エディタ"
    },
    seo: {
        default_title: "Mirinae Platform - Where Imagination Becomes Reality",
        default_desc: "Next-gen Webtoon/Webnovel platform combining AI and Art. Become an author and create your own universe."
    },
    footer: {
        terms: "利用規約",
        privacy: "プライバシーポリシー",
        report: "通報センター",
        biz_ceo: "代表者",
        biz_addr: "住所",
        biz_tel: "サポート",
        biz_email: "メール",
        biz_license: "事業者番号",
        biz_mail_order: "通信販売業",
        biz_none: "情報なし",
        system_ready: "SYSTEM READY",
        copyright: "SSULWHA WORLD"
    },
    menu: {
        home: "ホーム",
        webtoon: "ウェブトゥーン",
        webnovel: "ウェブ小説",
        novel: "ウェブ小説",
        davinci: "ダ・ヴィンチ",
        studio: "作家スタジオ",
        library: "ライブラリ",
        support: "サポート",
        admin: "管理",
        config: "外部リンク",
        factory: "ポップアップ & 通知",
        docs: "ドキュメントエディタ",
        analytics: "トレンド分析",
        plaza: "Ssulwhaクラブ",
        wisdom: "星の知恵",
        recommendation: "空の本棚",
        charge: "スターステーション",
        guide: "ガイド",
        "whats-new": "新着情報",
        invite: "友達招待",
        about: "サービス紹介",
        terms: "利用規約",
        privacy: "プライバシーポリシー",
        report: "通報センター",
        "app-setting": "アプリ設定",
        login: "ログイン / 登録",
        logout: "ログアウト",
        MyPage: "マイページ",
        notice: "お知らせ",
        proposal: "提案",
        settings: "設定",
        language: "言語"
    },
    modal: {
        translate_title: "言語選択",
        translate_placeholder: "翻訳する言語を選択してください。",
        translate_start: "翻訳"
    },
    msg: {
        welcome_beta: "Mirinaeのベータ版へようこそ。",
        login_required: "ログインして、もっと多くの物語を開きましょう。",
        login_btn: "ログイン / 登録"
    },
    profile: {
        follow: "フォロー",
        following: "フォロー中",
        mypage: "マイページ",
        followers: "フォロワー",
        following_count: "フォロー",
        bio_empty: "紹介文がありません。",
        works: "作品",
        feed: "フィード",
        guestbook: "ゲストブック",
        works_empty: "登録された作品がありません。",
        works_error: "作品の読み込みに失敗しました",
        feed_empty: "投稿された記事がありません。",
        feed_error: "フィードを読み込めません。",
        feed_error_detail: "インデックス作成中かネットワークエラーの可能性があります。",
        follow_error: "フォロー処理に失敗しました。"
    },
    support: {
        title: "1:1 お問い合わせ",
        input_placeholder: "お問い合わせ内容を入力してください...",
        empty_state_title: "お問い合わせ履歴がありません。",
        empty_state_desc: "気になる点はいつでもお問い合わせください！",
        status_received: " • 受付済み",
        auto_reply: "ご意見を受け付けました。順次回答させていただきます。それまでSsulwha Worldをお楽しみください。",
        send_fail: "メッセージ送信失敗"
    },
    author: {
        apply_title: "作家申請",
        apply_desc: "あなたの物語を世界に届けましょう。簡単な紹介とポートフォリオを残していただければ、審査後にご連絡いたします。",
        email_label: "メールアドレス",
        email_placeholder: "連絡可能なメールアドレスを入力してください",
        email_hint: "承認結果および契約に関するご連絡を差し上げる場合があります。",
        intro_label: "自己紹介",
        intro_placeholder: "ご自身について紹介してください。（執筆歴、作品スタイルなど）",
        portfolio_label: "ポートフォリオ（任意）",
        submit_btn: "申請する",
        email_required: "メールアドレスを入力してください。",
        intro_required: "自己紹介を入力してください。",
        submitting: "申請中...",
        submit_success: "作家申請が完了しました。"
    },
    point: {
        reason: {
            attendance: "Daily Attendance",
            reading: "Reading Reward",
            reading_reward: "Reading Reward",
            welcome: "Welcome Reward",
            referral: "Referral Reward",
            author_apply: "Author Application",
            rental: "Rental",
            purchase: "Purchase"
        }
    },
    wallet: {
        tab_title: "Wallet",
        sub_card: {
            upgrade_btn: "Upgrade Membership (₩{price}/mo)",
            coming_soon: "Coming Soon",
            tier_label: "Membership Tier",
            tier_premium: "Premium Pass",
            tier_standard: "Standard Member",
            renews_on: "Renews on"
        },
        assets: {
            activity_label: "Activity Points",
            activity_desc: "Free Earned Points",
            star_label: "Star Points",
            star_desc: "Paid Charged Points"
        },
        charge: {
            title: "Star Station",
            desc: "Charge needed stars"
        },
        history: {
            title: "Point History",
            empty: "No history found."
        }
    },
    history: {
        empty: {
            title: "まだ閲覧した作品がありません。",
            desc: "作品を探しに行きましょうか？",
            action_btn: "作品を探す"
        },
        common: {
            no_title: "タイトルなし"
        },
        last_viewed: "最後に見た:",
        episode_fmt: "第{n}話",
        delete_confirm: {
            msg: "この履歴を削除しますか？",
            title: "履歴の削除"
        }
    },
    library: {
        empty_title: "ライブラリは空です",
        empty_desc: "購入または閲覧した作品がここに表示されます。",
        explore_btn: "作品を探す",
        select_hint: "作品を選択するとリストが表示されます。",
        total_episodes: "全{n}エピソード"
    },
    badge: {
        best_reviewer: "ベストレビュアー",
        top_author: "トップ作家",
        vip: "VIP",
        donation_king: "寄付王",
        hall_of_fame: "殿堂入り"
    },
    tab: {
        works: "作品",
        feed: "Ssulwha (Feed)",
        guestbook: "ゲストブック"
    },
    tag: {
        fantasy: "ファンタジー",
        romance: "ロマンス",
        martial_arts: "武侠",
        drama: "ドラマ",
        slice_of_life: "日常",
        comedy: "コメディ",
        thriller: "スリラー",
        school: "学園",
        munchkin: "俺TUEEE",
        regression: "回帰",
        possession: "憑依",
        system: "システム",
        growth: "成長",
        revenge: "復讐",
        heart: "ハートフル",
        horror: "ホラー",
        sport: "スポーツ",
        history: "代替歴史"
    },
    guestbook: {
        title: "ゲストブック",
        input_placeholder: "応援のメッセージを残してください！",
        secret: "秘密",
        submit: "登録",
        empty: "最初のメッセージを残してください！ 👣",
        secret_content: "秘密のメッセージです。",
        delete_confirm: "削除しますか？",
        reply: "返信",
        reply_placeholder: "返信を入力...",
        reply_delete_confirm: "返信を削除しますか？",
        confirm_delete_reply: "この返信を削除しますか？",
        submit_error: "登録失敗：",
        emoji_error: "絵文字の読み込みに失敗しました"
    },
    pwa: {
        install_title: "インストール",
        install_desc: "より速く、より快適に。",
        install_btn: "インストール",
        later_btn: "あとで",
        ios_guide_title: "iPhoneにインストール",
        ios_guide_desc: "全画面で最高の体験を。",
        ios_step1: "「共有」ボタンをタップ",
        ios_step2: "「ホーム画面に追加」を選択",
        update_title: "新しいバージョン ({version})!",
        update_title_v2: "新しいバージョンが利用可能です！",
        update_desc: "新機能のために更新してください。",
        update_btn: "更新",
        updating: "更新中...",
        offline_title: "オフラインです",
        offline_desc: "インターネット接続を確認してください。",
        copy_success: "コピーしました",
        copy_fail: "コピー失敗"
    },
    settings: {
        title: "アプリ設定",
        general: "一般設定",
        push_title: "プッシュ通知",
        push_desc: "最新情報の通知を受け取る",
        app_info: "アプリ情報",
        current_version: "現在のバージョン",
        danger_zone: "Danger Zone",
        delete_account_title: "会員脱退 (現実に戻る)",
        delete_account_desc: "すべてのデータが削除され、復元することはできません。",
        delete_account_button: "現実に戻る"
    },
    proposal: {
        title: "星の知恵",
        desc: "あなたの輝く知恵が宇宙を広げます。",
        label_title: "提案のタイトル",
        placeholder_title: "アイデアの要点を入力してください",
        label_content: "詳細",
        placeholder_content: "自由にアイデアを共有してください。具体的であるほど良いです!",
        btn_submit: "知恵を送る",
        success_title: "知恵を受け取りました",
        success_desc: "{name}様の知恵が記録されました。<br>貴重なご意見ありがとうございます。"
    },
    report: {
        title: "通報センター",
        category_label: "CATEGORY",
        content_label: "CONTENT",
        url_label: "RELATED URL",
        categories: {
            general: "一般質問 / その他",
            spam: "スパム / 不適切な広告",
            abuse: "誹謗中傷 / ヘイトスピーチ",
            adult: "成人向けコンテンツ / 未成年に有害",
            bug: "システムエラー / バグ"
        },
        placeholder_content: "問題を詳しく説明してください。",
        btn_submit: "通報する",
        warning: "虚偽の通報はサービスの利用制限につながる可能性があります。",
        success_title: "通報完了",
        success_desc: "迅速に確認し、措置を講じます。<br>ご報告ありがとうございます。",
        login_required: "通報するにはログインが必要です。",
        submit_success: "通報が正常に送信されました。\n管理センターで確認してください...",
        error: "通報の送信中にエラーが発生しました",
        modal: {
            title: "通報",
            desc: "通報の理由を選択してください。虚偽の通報はサービスの利用制限につながる可能性があります。",
            category: "カテゴリー",
            detail: "詳細",
            url: "関連URL",
            submit: "送信",
            cancel: "キャンセル"
        },
        reason: {
            spam: "スパム / 宣伝",
            abusive: "誹謗中傷",
            inappropriate: "不適切なコンテンツ",
            other: "その他 / お問い合わせ"
        }
    },
    guide: {
        title: "システム設定",
        desc: "あなたの旅をサポートするために<br>コンパスを微調整しています。",
        wait: "少々お待ちください。"
    },
    viewer: {
        settings_title: "音声/スクロール設定",
        bgm_volume: "BGM音量",
        bgm_off: "BGMオフ",
        auto_speed: "自動速度",
        settings_btn: "設定",
        translate_btn: "AI翻訳",
        tts_btn: "TTS読み上げ",
        bgm_btn: "BGM",
        top_btn: "トップへ",
        auto_play: "自動スライド",
        auto_scroll: "自動スクロール",
        start_auto: "自動再生",
        stop_auto: "停止",
        tts_warn: "注: TTSは原文(韓国語)で読み上げます。"
    },
    login: {
        subtitle: "あなたの想像が現実に変わる場所",
        btn_google: "Googleで続ける",
        or: "または",
        label_email: "メールアドレス",
        label_password: "パスワード",
        btn_email_login: "メールでログイン",
        btn_email_signup: "メールで登録",
        msg_no_account: "アカウントをお持ちですか?",
        msg_has_account: "すでにアカウントをお持ちですか?",
        btn_signup: "登録",
        btn_login: "ログイン",
        msg_processing: "処理中...",
        msg_email_sent: "認証メールを送信しました。確認してログインしてください。",
        err_invalid_auth: "メールアドレスまたはパスワードが正しくありません。",
        err_email_in_use: "このメールアドレスは既に使用されています。",
        err_default: "エラーが発生しました。"
    },
    terms: {
        title: "入国審査",
        desc: "SSULWHAワールドへようこそ。<br>利用規約に同意してください。",
        required: "[必須]",
        optional: "[任意]",
        label_terms: "利用規約",
        label_privacy: "プライバシーポリシー",
        label_marketing: "マーケティング同意",
        btn_start: "始める",
        btn_processing: "処理中..."
    },
    main: {
        banner_welcome: "✨ 今すぐSSULWHAの世界を探検しましょう!",
        search_placeholder: "作品、作家、タグを検索...",
        hall_of_fame: "殿堂入り (Weekly Best)",
        hall_of_fame_locked: "殿堂入りはメンバーのみ閲覧可能です",
        hall_of_fame_desc: "今週最も活動的なユーザーは誰ですか? ログインしてランキングを確認しましょう!",
        login_btn: "ログイン",
        todays_pick: "今日のピックアップ",
        continue_reading: "続きを読む",
        trending: "トレンド",
        new_arrivals: "新着",
        all_works: "すべての作品",
        tag_cloud: "タグで探す",
        filter_all: "すべて",
        filter_webtoon: "ウェブトゥーン",
        filter_webnovel: "ウェブ小説",
        realtime_club: "リアルタイムSsulwhaクラブ",
        enter_club: "入場",
        be_the_first: "最初の星を打ち上げましょう!",
        go_to_plaza: "広場へ行く",
        search_results: "検索結果: '{query}'",
        search_no_results: "結果が見つかりませんでした。",
        search_try_other: "他のキーワードを試してください。",
        splash_loading: "Ssulwhaの世界へ...",
    },
    mypage: {
        tab_library: "ライブラリ",
        tab_history: "履歴",
        tab_activity: "活動",
        tab_likes: "お気に入り",
        tab_wallet: "ウォレット",
        tab_settings: "設定",
        no_activity: "活動履歴がありません。",
        go_to_plaza: "広場へ行く",
        followers: "フォロワー",
        following: "フォロー中",
        edit_profile_tooltip: "プロフ編集",
        role_author: "作家",
        role_reader: "読者",
        role_admin: "管理者",
        author_pending: "⏳ 承認待ち",
        btn_studio: "作家スタジオ",
        btn_apply_author: "作家になる",
        default_bio: "簡単な紹介を入力してください。",
        menu_edit_profile: "プロフィール編集",
        menu_public_profile: "公開プロフィール",
        current_version: "現在のバージョン",
        invite_title: "友達を招待",
        invite_reward: "報酬 +500P",
        invite_desc: "リンクを共有してください。あなたと友達の両方が500Pを獲得します!",
        invited_count: "招待した友達",
        unit_people: "人",
        edit_profile_title: "プロフィール編集",
        label_photo: "プロフィール写真",
        btn_upload: "アップロード",
        btn_random: "ランダム",
        placeholder_photo_url: "または画像URL",
        label_nickname: "ニックネーム",
        label_bio: "自己紹介",
        placeholder_bio: "簡単な自己紹介"
    },
    plaza: {
        title: "Ssulwhaクラブ",
        subtitle: "Z世代のための感情コミュニケーション空間",
        btn_sync: "⚡ コメント同期 (Admin Only)",
        composer_placeholder_init: "この宇宙にどんな物語を打ち上げますか?",
        composer_placeholder_thread: "物語の続きを書く...",
        composer_placeholder_quote: "この物語についての考えを残してください...",
        btn_add_thread: "スレッドを追加",
        btn_submit: "星を打ち上げる",
        btn_submit_quote: "引用する",
        btn_submitting: "アップロード中...",
        quote_suffix: "さんが引用"
    },
    recommendation: {
        loading_title: "あなたの軌道を読んでいます...",
        loading_desc: "過去の足跡とあなたが留まった星々をつなげています",
        fallback_title: "<span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span>様の星座は<br>まだ薄く見えます。",
        fallback_desc: "でも心配しないでください。<br>他の多くの人々の夜を照らした輝く物語を選びました。<br><span class=\"text-sm opacity-70 mt-1 block\">あなたの足跡が増えるにつれて、あなただけの軌道を見つけるでしょう。</span>",
        personal_title: "<span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span>様の本棚、<br>次のスロットのための物語",
        personal_desc: "あなたの好みに響く5つの星を見つけました。",
        label_empty_shelf: "空の本棚 (The Empty Shelf)",
        btn_refresh: "他のおすすめ",
        error_title: "接続が不安定です",
        btn_retry: "再試行",
        empty_data_title: "データ不足",
        btn_browse: "作品を見る",
        widget_title: "次の本を<br>お探しですか?",
        widget_desc: "{name}様の好みに基づいて5つの作品を選びました。",
        widget_desc_guest: "あなたの好みに基づいて5つの作品を選びました。",
        btn_check: "今すぐ見る"
    },
    star_station: {
        title: "スターステーション",
        subtitle: "作品をより自由に楽しんでください。",
        my_stars: "マイスター",
        history_tab: "履歴",
        products_tab: "商品",
        payment_method: "支払方法",
        btn_charge: "チャージ",
        history_empty: "チャージ履歴がありません。",
        product_names: {
            stardust: "スターダスト",
            shooting_star: "流れ星",
            little_bear: "リトルベア",
            silver_river: "シルバーリバー",
            galaxy_master: "ギャラクシーマスター",
            star_maker: "スターメーカー"
        }
    },
    studio: {
        title: "クリエイティブスタジオ",
        desc: "あなたの無限の想像力のための空間。",
        dashboard: "ダッシュボード",
        series: "シリーズ管理",
        statistics: "統計",
        profit: "収益",
        guide: "作家ガイド",
        new_series: "新しいシリーズ",
        edit_series: "シリーズ編集",
        new_episode: "新しいエピソード",
        edit_episode: "エピソード編集",
        open_menu: "メニューを開く",
        exit: "終了",
        lab_badge: "LAB",
        lab_title: "ダ・ヴィンチ ラボ",
        lab_desc: "AIで新しい創作の世界を開きましょう。",
        total_views: "閲覧数",
        total_likes: "いいね",
        total_followers: "フォロワー",
        weekly_performance: "週間パフォーマンス",
        views_trend_7d: "閲覧トレンド(7日間)",
        live_data: "LIVE",
        my_series_list: "私の作品",
        total_series_count: "全{n}作品",
        empty_series_title: "新しい物語を始めましょう",
        empty_series_desc: "世界へあなたの想像力を広げてください。",
        btn_editor: "エディタ",
        btn_settings: "設定",
        btn_delete: "削除",
        delete_modal_title: "シリーズ削除",
        create_first_episode: "最初のエピソードを作成しましょう!",
        create_first_episode_desc: "「新しいエピソード」ボタンをクリックして始めましょう。",
        last_updated: "最終更新: {date}",
        delete_episode_title: "エピソード削除",
        delete_episode_content: "エピソード '{title}' を削除してもよろしいですか?",

        // Toolbar
        bold: "太字",
        italic: "斜体",
        highlight_red: "ハイライト (赤)",
        highlight_blue: "ハイライト (青)",
        save_preserve_status: "現在の状態を維持して保存",
        delete_modal_content: "本当に '{title}' を削除しますか? この操作は取り消せません。"
    },
    editor: {
        davinci_editor: "ダ・ヴィンチ エディタ",
        webnovel_editor: "ウェブ小説エディタ",
        webtoon_editor: "ウェブトゥーンエディタ",
        episode_title: "エピソードタイトル",
        placeholder_title: "エピソードのタイトルを入力",
        content: "内容",
        placeholder_content: "ここに物語を書いてください...",
        author_note: "作家のメモ",
        placeholder_note: "読者への一言...",
        upload_image: "画像アップロード",
        upload_cover: "表紙アップロード",
        save_draft: "下書き保存",
        publish: "公開",
        ai_analysis: "AI分析",
        ai_recommend: "AIおすすめ",
        tags: "タグ",
        placeholder_tags: "タグを追加(カンマ区切り)",
        preview: "プレビュー",
        settings: "設定",
        episode_prefix: "エピソード",
        draft_mode_title: "下書きモード",
        draft_mode_private_desc: "このエピソードは現在非公開です。",
        display_mode: "表示モード",
        mode_webtoon: "ウェブトゥーン(スクロール)",
        mode_comic: "コミック(ページ)",
        mode_insta: "インスタトゥーン",
        mode_desc: "視聴体験を最適化します。",
        cover_image: "カバー画像",
        cover_url: "表紙URL",
        series_status: "シリーズ状態",
        admin_info: "管理者情報",
        format: "形式 (Format)",

        publish_now: "今すぐ公開",
        thumbnail: "サムネイル",
        bgm: "BGM",
        manuscript_images: "原稿",
        drag_drop_hint: "画像をドラッグ&ドロップ または タップしてアップロード",
        set_draft: "下書きへ",
        save_changes: "変更を保存",
        live_preview: "ライブプレビュー",
        preview_hint: "モバイル端末での表示を確認してください。",
        val_webtoon_error: "[ウェブトゥーンモードエラー] 画像が広すぎます(比率: {ratio})。<br>ウェブトゥーンモードは縦スクロールが必要です(高さ > 幅 * 1.2)。<br>単一ページの場合は「コミック」モードを使用してください。",
        val_comic_error: "[コミックモードエラー] 無効なアスペクト比({ratio})です。<br>許可される形式:<br>- 縦ページ(約2:3〜3:4)<br>- 横見開き(幅 > 高さ)<br><br>長いスクロールストリップは「ウェブトゥーン」モードを使用してください。",
        val_insta_error: "[インスタトゥーンエラー] 無効なアスペクト比({ratio})です。<br>Instagram向け最適化には正方形(1:1)またはポートレート(4:5)が必要です。<br>現在の画像は幅が広すぎるか高すぎます。",
        approval_requested: "承認リクエスト済み",
        approval_desc: "このシリーズの最初の公開です。<br>管理者がまもなく確認します。",
        pending_approval: "承認待ち",
        saved_to_draft: "下書きに保存しました",
        published_start_ai: "エピソード公開! AI分析を開始します...",
        ai_trigger_fail: "AI分析の開始に失敗しました。手動で「AI分析」ボタンを使用してください。",
        save_failed: "保存エラー: {e}",
        upload_complete: "アップロード完了",
        upload_fail_desc: "画像のアップロードに失敗しました。(URL生成失敗)\n開発者ツールのコンソールログを確認してください。",
        image_mode_mismatch: "選択した画像は{mode}モードの規格に合っていません。",
        invalid_format: "規格違反",
        mode_change_blocked: "モード変更不可",
        mode_change_blocked_desc: "既存の画像の中に{mode}規格に合わないファイルがあります。該当する画像を削除してから再試行してください。",
        processing: "処理中...",
        tap_nav_hint: "端をタップして移動 または スクロール",
        ai_analyze_title: "AI分析の確認",
        ai_analyze_confirm: "これらの画像でAI分析(OCR)を実行しますか?\\n既存の分析データは更新されます。",
        save_required: "まずエピソードを保存してください。",
        ai_requesting: "AIサーバーへリクエスト中... (OCR/SEO)",
        ai_processing_title: "AI処理中",
        ai_no_items: "分析された項目はありません(0)。\\n\\n[詳細]\\n{log}",
        diagnosis_report: "診断レポート",
        ocr_complete: "OCR完了: {n}フレーム",
        seo_trigger: "自動SEO生成がトリガーされました。",
        ai_complete_desc: "分析完了。\\n- OCRデータ作成済み\\n- SEOメタデータ待機中\\n(まもなく表示されます)",
        ai_error: "AI処理エラー",
        ai_fail_msg: "AI分析失敗: {e}",
        title: "Novel Studio",
        master_detail: "Master-Detail View",
        save: "保存",
        saved: "保存済み",
        saving: "保存中...",
        complete: "完了",



        error: "エラー",
        ai_analyze_btn: "AI分析",
        ai_analyzing: "分析中...",
        series_info: "シリーズ情報 (Upload)",
        series_title: "シリーズタイトル",

        admin_readonly: "管理者のみ (Read Only)",
        chapters: "チャプターリスト",
        add_chapter: "チャプター追加",
        delete_chapter_confirm: "このチャプターを削除しますか?",
        untitled_episode: "無題",
        bgm_label: "BGM (オプション)",
        content_body: "本文",
        load_txt: "TXT読み込み",
        text_too_short: "本文が短すぎます。",
        upload_cover_fail: "表紙アップロード失敗",
        create_series: "シリーズ作成",
        edit_series: "シリーズ編集",
        basic_info: "基本情報",
        episode_mgmt: "エピソード管理",
        compliance: "コンプライアンス (Compliance)",
        age_rating: "年齢制限",
        age_guide: "ガイド",
        is_ai: "AIコンテンツ使用",
        desc_placeholder: "あらすじを入力...",


        format_locked: "ロック",
        webtoon: "ウェブトゥーン (Webtoon)",
        webnovel: "ウェブ小説 (Webnovel)",
        cinenovel: "シネノベル (Cine-Novel)",
        admin_id: "IDコード (Admin Only)",
        ai_context_analysis_confirm: "AI文脈分析を実行しますか？\n(既存のデータは上書きされます)",
        ai_analyzing_background: "AI分析をリクエスト中... (バックグラウンド)",
        ai_no_items_found: "分析された項目はありません...",
        upload_fail: "アップロード失敗: ",
        creating_episode: "新しいエピソードを作成中...",
        episode_not_found: "エピソードが見つかりません。",
        uploading_images_toast: "画像をアップロード中...",
        approval_request_sent: "承認リクエストを送信しました。(管理者確認待ち)",
        publish_success: "公開しました！",
        temp_saved_toast: "一時保存されました。",
        deleted_toast: "削除されました。",
        access_denied: "アクセス拒否",


        series_info_upload: "シリーズ情報 (アップロード)",
        cover_upload_fail: "表紙のアップロードに失敗しました: ",
        save_success: "保存完了",
        publish_confirm: "公開確認",


        free_limit: "無料エピソード設定",
        free_limit_placeholder: "空白の場合、デフォルト設定が適用されます",
        free_limit_desc: "* 設定すると全体設定より優先されます。(0で有料)",
        admin_edit_anytime: "* 管理者はいつでも編集可能です。",
        cancel: "キャンセル",
        create: "作成",
        episode_list: "エピソード一覧",
        status_published: "公開済み",
        status_draft: "下書き",
        edit_detail_guide: "詳細はエディタで編集",
        refreshing_list: "リスト更新中...",
        load_fail: "読み込み失敗: ",
        no_cover: "表紙なし",
        badge_ai: "AI生成",
        no_episodes: "エピソードがありません。",
        open_editor_fullscreen: "エディタを開く (全画面)",
        editor_guide_text: "* 順序変更や詳細は「エディタを開く」を使用してください。",
        admin_zone: "管理者エリア",
        admin_zone_desc: "この情報は管理者のみ表示されます。",
        download_csv: "ISBN用CSVダウンロード",
        adult_confirm_title: "成人向け設定の警告",
        adult_confirm_body: "成人向け(19+)に設定しますか？\n- 未成年のアクセスがブロックされます。\n- 本人確認が必要になる場合があります。",
        davinci_lock_title: "🚧 準備中",
        davinci_lock_desc: "DaVinciモードは現在ベータ版です。<br>安定性のため管理者のみアクセス可能です。",
        preview_preparing: "プレビュー準備中...",


        publish_settings: "Publish Settings",
        ai_analyze_local: "AI Context Analysis",
        ai_confirm: "AI Confirmation",
    },

    rating_guide: {
        title: "コンテンツレーティングガイド",
        all_title: "全年齢",
        all_desc: "すべての年齢層に適したコンテンツです。<br>暴力、性的な内容、不適切な言葉遣いが含まれていないか、非常に軽微です。",
        title_12: "12+ (Teens)",
        desc_12: "軽度の暴力、悪い言葉遣い、またはホラーが含まれる場合があります。<br>12歳未満の子供には保護者の指導が推奨されます。",
        title_15: "15+ (Young Adults)",
        desc_15: "中程度の暴力、強い言葉遣い、または成熟したテーマが含まれる場合があります。<br>犯罪行為や社会的タブーを描写する場合があります。",
        title_19: "19+ (Adults Only)",
        desc_19: "露骨な性的な内容、極端な暴力、または虐待的な言葉遣いが含まれます。<br><strong class='text-red-500'>法的に19歳以上の成人に制限されています。本人確認が必要です。</strong>",
        disclaimer: "* レーティングは作家の責任です。虚偽のレーティングは強制的な変更やペナルティにつながる可能性があります。",
        confirm: "理解しました"
    },
    davinci: {
        episode_settings: "エピソード設定",
        title: "タイトル",
        thumbnail: "サムネイル",
        bgm: "BGM",
        add_block: "ブロック追加",
        text_block: "テキスト",
        image_block: "画像",
        upload_image: "写真アップロード",
        upload_thumb: "サムネイルアップロード",
        upload_success: "アップロード完了",
        bgm_placeholder: "Suno URL または MP3リンク",
        tip: "ヒント:",
        drag_tip: "ブロックをドラッグして並べ替え。",
        save_draft: "下書き保存",
        publish: "公開",
        saving: "保存中...",
        published: "公開されました! 読者が閲覧可能です。",
        publish_confirm: "公開しますか? 読者に表示されます。",
        preview_preparing: "プレビュー準備中...",
        thumbnail_uploading: "サムネイルアップロード中...",
        thumbnail_applied: "サムネイル適用済み",
        guide: {
            title: "ボタンガイド",
            save: "保存",
            save_desc: "変更を保存します。",
            draft: "下書き",
            draft_desc: "非公開に切り替えます。",
            publish: "公開",
            publish_desc: "公開します。(読者が閲覧可能)",
            auto_save: "自動保存",
            auto_save_on: "ON (3秒)",
            auto_save_desc: "3秒ごとに自動保存されます。"
        }
    },
    intro: {
        slogan: "人間の創造性、AIの拡張性",
        hero_title: "シネノベルのための",
        hero_subtitle: "バベルフィッシュ",
        status_active: "リアルタイム翻訳稼働中",
        status_cine: "シネノベルフォーマット",
        desc_1: "韓国のウェブトゥーンを<span class='text-white font-bold mx-1'>10ヶ国語</span>で瞬時に。非破壊AI翻訳エンジンが実現します。",
        desc_2: "ビジュアルと小説が融合した<span class='text-white font-bold mx-1'>世界初のハイブリッドフォーマット</span>を体験してください。",
        cta_start: "無料で読み始める",
        compare_title: "破壊的翻訳 vs 非破壊エンジン",
        compare_desc: "オリジナルの画を一切傷つけません。その違いをご覧ください。",
        compare_old: "従来方式 (ホワイトボックス)",
        compare_new: "Ssulwhaエンジン (R.A.P.S)",
        white_box_removed: "除去されたホワイトボックス",
        format_title: "静止画を超えて",
        format_desc: "ウェブトゥーンの没入感。小説の深み。映画のような体験。",
        geo_title: "AI主導の成長",
        geo_desc: "マーケティングはしません。AIが代行します。",
        term_log_1: "コンテンツ分析中...",
        term_log_2: "キーワード抽出中...",
        term_log_3: "SEOメタデータ注入中...",
        term_log_4: "オーガニック成長 +300%",

        // Missing Keys Added
        slider_old_title: "従来方式",
        slider_old_desc: "アートを隠してしまう",
        slider_new_title: "Ssulwhaエンジン (R.A.P.S)",
        slider_new_desc_1: "「本来こうあるべきだ。」",
        slider_new_desc_2: "テキストが自然に浮かび、アートを完全に保存します。",

        phone_analyzing: "分析中...",
        phone_detected: "検出",
        phone_text_1: "これが私の運命か？",
        phone_cine_ep: "シネノベル EP.01",
        phone_cine_text_1: "ネオンライトが点滅し、彼の冷たい瞳に反射した。",
        phone_cine_text_2: "「ただの翻訳ではない」彼は呟いた。「新しい現実だ。」",

        footer_copyright: "Powered by R.A.P.S Engine."
    }
};
